import styled from 'styled-components';

export interface IconProps {
  isWarn?: boolean;
}

export const Root = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
`;

export const Content = styled.div`
  position: relative;
  z-index: 10;
  width: 92vw;
  max-width: 500px;
  background: #ffffff;
  padding: 42px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  outline: none;
`;

export const Close = styled.button`
  position: absolute;
  right: 16px;
  top: 16px;
  border: 0;
  background: transparent;
  color: #6b7280;
  padding: 4px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    color: #fd5d5d;
  }

  .anticon {
    font-size: 18px;
  }
`;

export const OuterIcon = styled.div<{ isWarn?: boolean }>`
  margin: 0 auto 16px;
  width: 96px;
  height: 96px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: ${props => (props.isWarn ? '#fb923c' : '#a3e635')};
`;

export const InnerIcon = styled.div<{ isWarn?: boolean }>`
  width: 80px;
  height: 80px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: ${props => (props.isWarn ? '#f97316' : '#84cc16')};
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.primary};
  margin: 0;
`;

export const Message = styled.p`
  margin: 12px auto 0;
  max-width: 520px;
  text-align: center;
  font-size: 15px;
  color: #374151; /* gray-700 */
`;

export const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;

export const PrimaryButton = styled.button`
  border: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary};
  color: #ffffff;
  padding: 8px 24px;
  cursor: pointer;
  transition: opacity 0.15s ease-in-out;

  &:hover {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid #0b4b75;
    outline-offset: 2px;
  }
`;
